module.exports = __webpack_public_path__ + "img/luxury_estate_pinpoint.8c3c70d2.svg";